// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".App_root__2CSG3 {\n  height: 100vh;\n  overflow: hidden; }\n  .App_root__2CSG3 .App_container__eSJ6i {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    width: 100%;\n    height: 100vh;\n    background: #fff;\n    position: absolute;\n    overflow: hidden;\n    top: 0;\n    left: 0;\n    z-index: 10001; }\n    .App_root__2CSG3 .App_container__eSJ6i .App_loader__Dop8H {\n      margin-top: 10px;\n      margin-bottom: 10px; }\n\n.App_main__uN9ca,\n.App_mainFullWidth__1PAJK {\n  display: flex;\n  flex-direction: column;\n  width: calc(100% - 80px);\n  height: 100vh;\n  overflow: hidden;\n  background: #fafafa; }\n\n.App_mainFullWidth__1PAJK {\n  width: 100%; }\n\n.App_appContent__1pITD {\n  display: flex;\n  overflow: hidden;\n  max-height: 100vh; }\n", ""]);
// Exports
exports.locals = {
	"root": "App_root__2CSG3",
	"container": "App_container__eSJ6i",
	"loader": "App_loader__Dop8H",
	"main": "App_main__uN9ca",
	"mainFullWidth": "App_mainFullWidth__1PAJK",
	"appContent": "App_appContent__1pITD"
};
module.exports = exports;
